import reasonCodes from './reasonCodes';
import blockedReasons from './blockedReasons';

export const receipt  = {
    reasonCodes,
    blockedReasons
};
